import React from 'react';
import { X } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { t } from '../../constants/i18n';

interface CartDrawerHeaderProps {
    count: number;
    onClose: () => void;
}

export const CartDrawerHeader: React.FC<CartDrawerHeaderProps> = ({ count, onClose }) => {
    return (
        <>
            <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between bg-white shrink-0 z-40">
                <div className="flex items-end gap-2">
                    <div className="text-2xl font-bold tracking-tight text-gray-900"
                    style={{ all: 'unset', display: 'block', fontSize: '1.5rem', fontWeight: 'bold' }}>
                        {t('cartTitle')}
                    </div>
                    <span className="text-sm font-bold --font-weight-medium text-gray-500 mb-1">
                       ( {count} )
                    </span>
                </div>
                <button
                    onClick={onClose}
                    className="p-2 -mr-2 text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors"
                >
                    <X size={24} />
                </button>
            </div>
            <Separator />
        </>
    );
};
